export default {
  browsePanes: {},
  reloadTimestrips: 0,
  draggableCamId: null
};